import { environmentConfig } from "@src/appV2/environment";

export const NEWS_FEED_URL = `${environmentConfig.REACT_APP_API_MAIN_URL}/api/news-feed-items`;
export const NEWS_FEED_COMMENT_URL = `${NEWS_FEED_URL}/:newsFeedItemId/comment`;
export const NEWS_FEED_REACTION_URL = `${NEWS_FEED_URL}/:newsFeedItemId/reaction`;
